import React, { useState, useEffect } from 'react';
import styles from './SsoSection.module.css';
import { toast } from '../../lib/toast';
import { idpProvidersApi } from '../../lib/apiClient';
import { useNavigate } from 'react-router-dom';
import { useProvidersStore } from '../../store/providersStore';
import { getProviderIcon } from '../../lib/idpProviderIcons';

interface SsoSectionProps {
  loading: boolean;
  oauthParams?: Record<string, string>;
  fromLogin?: boolean;
}

const SsoSection: React.FC<SsoSectionProps> = ({ loading, oauthParams, fromLogin }) => {
  const [ssoLoading, setSsoLoading] = useState<string | null>(null);
  const navigate = useNavigate();
  const providers = useProvidersStore(state => state.safeProviders);
  const fetchProviders = useProvidersStore(state => state.fetchProviders);

  useEffect(() => {
    if (providers.length === 0) {
      fetchProviders();
    }
  }, []);

  const handleSsoLogin = async (providerId: string) => {
    if (!fromLogin && !oauthParams?.sessionId) {
      toast.error('Missing OAuth session. Please restart the Claude connection flow.');
      return;
    }

    setSsoLoading(providerId);
    try {
      const res = await idpProvidersApi.getUrl(
        providerId,
        `${import.meta.env.VITE_API_OAUTH_BASE_URL}/idp/${fromLogin ? 'login' : 'callback'}`,
        oauthParams?.sessionId!
      );
      
      if (res.login_url)
        window.location.href = res.login_url;
      else if (res.success) {
        navigate('/dashboard');
        toast.success(`Welcome ${res.user.firstName}!`);
      }
    } catch (err: any) {
      toast.error(`SSO login failed: ${err.message}`);
    } finally {
      setSsoLoading(null);
    }
  };

  if (providers.length === 0) return null;

  return (
    <div className={styles.ssoSection}>
      <hr className={styles.divider} />
      <p className={styles.orLabel}>or continue with</p>
      <div className={styles.ssoButtons}>
        {providers.filter((provider) => provider.active).map((provider) => (
          <button
            key={provider.id}
            onClick={() => handleSsoLogin(provider.id)}
            disabled={loading || ssoLoading === provider.id || (!fromLogin && !oauthParams?.sessionId)}
            className={styles.ssoButton}
          >
            {getProviderIcon(provider.type)}
            {ssoLoading === provider.id ? 'Connecting...' : provider.name}
          </button>
        ))}
      </div>
    </div>
  );
};
export default SsoSection;
